<template>
  <section id="storeManager">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer
      absolute
      temporary
      right
      v-model="drawer"
      class="pa-2"
      style="top: 50px; bottom: 120px; height: auto"
    >
      <v-form class="mx-2">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              clearable
              :items="regionList"
              outlined
              dense
              hide-details
              label="区域"
              v-model="payload.regionCode"
              item-text="regionName"
              item-value="regionCode"
              @change="setRegion($event)"
              v-if="isAdmin"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              outlined
              clearable
              hide-details
              dense
              label="省/直辖市 "
              :items="provinceList"
              v-model="payload.provinceCode"
              item-value="code"
              item-text="name"
              @change="setProvince($event)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              outlined
              clearable
              hide-details
              dense
              v-model="payload.cityCode"
              label="市"
              :items="cityList"
              item-value="code"
              item-text="name"
              @change="setCity($event)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0" v-if="!this.user.role?.includes('Sales')">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
              :items="salesList"
              outlined
              hide-details
              dense
              clearable
              label="销售姓名"
              item-value="id"
              item-text="displayName"
              v-model="payload.salesId"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
          outlined
          dense
          clearable
          hide-details
          label="合作状态"
          item-value="id"
          item-text="name"
          :items="hzzt"
          v-model="payload.collaborateState"
        ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0 pt-2">
            <v-autocomplete
          outlined
          dense
          clearable
          hide-details
          label="门店级别"
          item-value="id"
          item-text="name"
          :items="mdlx"
          v-model="payload.categoryId"
        ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <template v-slot:append>
        <v-row class="ma-0">
          <v-btn class="primary white--text" @click="clearSearch">清空搜索</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="search">搜索</v-btn>
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-form class="mx-2">
      <v-row class="ma-0">
        <div class="breadcrumb font-weight-black">
          {{ breadcrumb }}
          <v-btn color="primary" @click="gotoAuthor">
            <span class="mendian">门店审批</span>
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click.stop="drawer = !drawer">
          筛选
        </v-btn>
        <v-btn class="primary white--text ml-2" @click="redirectToList"
          >查看详情</v-btn
        >
      </v-row>
    </v-form>

    <div id="storeCharts" class="pa-2 mt-0">
      <v-card class="mb-2">
        <v-simple-table height="400px">
          <template v-slot:default>
            <thead>
              <tr class="success">
                <th class="text-left font-weight-bold white--text">区域</th>
                <th class="text-left font-weight-bold white--text">FS</th>
                <th class="text-left font-weight-bold white--text">BS</th>
                <th class="text-left font-weight-bold white--text">PSY</th>
                <th class="text-left font-weight-bold white--text">PSW</th>
                <th class="text-left font-weight-bold white--text">Total</th>
              </tr>
            </thead>
            <tbody id="dataTable">
              <tr v-for="item in table" :key="item.name">
                <td>{{ item.regionName }}</td>
                <td>{{ item.fs }}</td>
                <td>{{ item.bs }}</td>
                <td>{{ item.psy }}</td>
                <td>{{ item.psw }}</td>
                <td>{{ item.total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <Bar :data="barData" :xAxisData="xAxisData" />
    </div>
    <!-- <v-row class="ma-0 pt-2 action">
      <v-spacer></v-spacer>
      <v-btn
        outlined
        tile
        class="primary white--text ml-2"
        @click="redirectToList"
        >查看详情</v-btn
      >
    </v-row> -->
  </section>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/api";
import Bar from "./Bar.vue";
export default {
  components: {
    Bar,
  },
  data: () => ({
    breadcrumb: "",
    drawer: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    loading: false,
    table: [],
    barData: [],
    xAxisData: [],
    hzzt: [],
    mdlx: [],
    payload: {
      dealerId: null,
      regionCode: null,
      provinceCode: null,
      cityCode: null,
      salesId: null,
      addDate: null,
      collaborateState:null,
      categoryId:null,
    },
    provinceList: [],
    cityList: [],
    salesList: [],
    items: [
      {
        name: "一级",
        value: 1,
      },
      {
        name: "二级",
        value: 2,
      },
    ],
    regionList: [],
  }),
  created() {
    this.loading = true;
    this.getCategroy();
    this.getRegion();
  },
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.role?.includes('HOD') || this.user.role?.includes('RRS') || this.user.role?.includes('SCN');
    },
  },
  methods: {
    gotoAuthor(){
      // window.location.href = "https://dev.salesclub.bosch-homecomfort.cn/rec/index.html#/";
      // window.location.href = process.env.VUE_APP_API_BASE_URL + "rec/index.html#/";
      window.location.href = process.env.VUE_APP_HOME_REC + "MobileReviewList";
    },
    getCategroy() {
      api.common.getAllCategory().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.hzzt = data.list.filter((i) => i.categoryType == "hzzt");
          this.mdlx = data.list.filter((i) => i.categoryType == "mdlx");
        }
      });
    },
    setRegion($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion.provinces);
        this.getSaleList();
      } else {
        this.provinceList = [];
      }
    },
    setRegionForInit($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion.provinces);
      } else {
        this.provinceList = [];
      }

      this.payload.regionCode = this.$route.query.region || "";
      this.payload.provinceCode = this.$route.query.province || "";
      this.payload.cityCode = this.$route.query.city || "";
      this.payload.salesId = this.$route.query.salesId || "";
      if (this.payload.salesId) {
        this.payload.salesId = Number(this.payload.salesId);
      }

      this.payload.collaborateState = this.$route.query.developmentStatus || "";

      if(this.payload.collaborateState){
        this.payload.collaborateState = Number(this.payload.collaborateState);
      }

      this.payload.categoryId = this.$route.query.categoryIdList || "";

      if(this.payload.categoryId){
        this.payload.categoryId = Number(this.payload.categoryId);
      }

      if (this.payload.provinceCode) {
        this.cityList = api.pca.getCityByProvince(this.payload.provinceCode);
      } else {
        this.cityList = [];
      }
    },
    getRegion() {
      api.pca.getRegion().then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.regionList = data;
          if (
            Object.prototype.hasOwnProperty.call(this.$route.query, "region") ||
            Object.prototype.hasOwnProperty.call(this.$route.query, "salesId")
          ) {
            this.payload.regionCode = this.$route.query.region || "";
            this.setRegionForInit(this.payload.regionCode);
          } else if (!this.isAdmin) {
            this.setRegion(this.user.userRegionCode);
            this.payload.regionCode = this.user.userRegionCode;
            if (this.user.role?.includes('Sales')) {
              this.salesId = this.user.userId;
            }
          }
          this.getSaleList();
          this.search();
        }
      });
    },
    getProvince(byRegion) {
      if (byRegion) {
        this.provinceList = api.pca.getProvince().filter((i) => {
          return (
            byRegion.filter((pro) => pro.provinceCode === i.code).length > 0
          );
        });
      } else {
        this.provinceList = api.pca.getProvince();
      }
    },
    setProvince($event) {
      this.cityList = api.pca.getCityByProvince($event);
      this.payload.cityCode = "";
    },
    setCity() {
      // this.getSaleList();
    },
    getSaleList() {
      api.user
        .getUserWithRoleAndRegion("Sales", this.payload.regionCode)
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.salesList = data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirectToList() {
      this.$router.push({
        path: "/store/list",
        query: {
          region: this.payload.regionCode,
          province: this.payload.provinceCode,
          city: this.payload.cityCode,
          salesId: this.payload.salesId,
          developmentStatus:this.payload.collaborateState,
          categoryIdList:this.payload.categoryId
        },
      });
    },
    clearSearch(){
      if (this.isAdmin) {
        this.payload.regionCode = null; 
      }
      if (!this.user.role?.includes('Sales')) {
        this.payload.salesId = null;
      }
      this.payload.provinceCode = null;
      this.payload.cityCode = null;
      this.payload.collaborateState = null;
      this.payload.categoryId = null;
      this.search();
    },
    async search() {
      if (this.user.role?.includes('Sales')) {
        this.payload = {
          ...this.payload,
          salesId: this.user.userId,
        };
      }
      
      this.loading = true;

      try {
        const tableDataRes = await api.store.getStorebyRegion(this.payload);
        const chartDataRes = await api.store.getStorebyCity(this.payload);
        if (tableDataRes.data.data && tableDataRes.data.status === 200) {
          const { data } = tableDataRes.data;
          this.table = data.map((i) => {
            const total =
              Number(i.bo) + Number(i.bs) + Number(i.fs) + Number(i.so);
            return {
              ...i,
              total,
            };
          });
        }
        if (chartDataRes.data.data && chartDataRes.data.status === 200) {
          const { data } = chartDataRes.data;
          this.barData = data.map((i) => i.count);
          this.xAxisData = data.map((i) => i.cityName);
        }
        if (!this.table.length && !this.barData.length) {
          this.message = {
            show: true,
            type: "info",
            text: "没有数据！",
          };
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        }
        this.loading = false;
        this.drawer = false;
      } catch (error) {
        console.log(error);
        this.drawer = false;
        this.loading = false;
        this.message = {
          show: true,
          type: "error",
          text: "数据加载失败，请重试！",
        };
        setTimeout(() => {
          this.message.show = false;
        }, 600000);
      }
    },
  },
};
</script>

<style lang="sass">
#storeManager
  height: 100%
  width: 100%
  #storeCharts.isRM
    height: calc( 100% - 160px )
  #storeCharts.isSale
    height: calc( 100% - 200px )
  #storeCharts
    height: calc( 100% - 50px )
    width: 100%
    overflow: auto
    #dataTable tr:nth-child(even)
      background-color: #eee
  .action
    position: absolute
    bottom: 3px
    left: 10px
    right: 10px
</style>
<style>
  .mendian{
    color: #ffffff;
    text-decoration: none;
  }
</style>
